import React, { useRef } from "react";
import { useRollbar } from "@rollbar/react";
import { useMount } from "react-use";

import { useIncode } from "./IncodeContext";

interface Props {
  numberOfTries: number;
  next: string;
}

export const Retry = ({ numberOfTries, next }: Props) => {
  const containerRef = useRef(null);
  const { incode, token, onComplete, track } = useIncode();
  const rollbar = useRollbar();

  useMount(() => {
    incode.renderRetrySteps(
      containerRef.current,
      {
        token: { token },
        numberOfTries,
      },
      {
        onSuccess: async () => {
          await incode
            .getFinishStatus(null, { token })
            .then(() => {
              track("retry_success");
              onComplete();
            })
            .catch((error: any) => {
              rollbar.error("Incode Finish Status Error", error);
              track("retry_error");
            });
        },
        onError: (error: any) => {
          rollbar.error("Incode Retry Error", error);
          track("retry_error");
        },
      },
    );
  });

  return <div ref={containerRef}></div>;
};
